import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const FlowerRose = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.88 5.668c-1.374 1.174-2.814 1.506-5.506 1.224-3.1-.323-4.973-1.822-4.2-3.265.618-1.154 3.125-1.856 5.6-1.567 1.98.231 3.183 1.166 2.688 2.09-.4.738-2 1.206-3.584 1A4.4 4.4 0 0 1 9.7 4.494m7.3 1.27c0 2.759-1.46 7.87-5.156 7.87s-4.836-5.111-4.836-7.87m4.847 9.036a18 18 0 0 1-.109 7.208m.506-3.846a3.26 3.26 0 0 1 3.826-1.981s.711 3.507-3.584 3.411m-.518-3.053a3.26 3.26 0 0 0-4.168-1.088s.08 3.578 4.248 2.536"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(FlowerRose) as SvgIcon;
export { ForwardRef as ReactComponent };
